import { Info } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';

/**
 * Nota de apoio de um passo do wizard.
 *
 * - `tone="note"` (default) — bloco `nota` dos frames `Onboarding · …` no `.pen`:
 *   `$surface-card` + `$border`, `rounded-$radius-ds-lg`, `padding $space-4`,
 *   ícone 20px `$sage-600`, título `$type-label-lg` 600, corpo `$type-body-sm`.
 * - `tone="sage"` — `ds/message--sage` (J4ENuG): `$sage-tint` + `$sage-border`,
 *   `padding [$space-2-5, $space-3]`, ícone 16px, texto `$type-body` 600.
 */
export function WizardHelpNote({
  children,
  title,
  className,
  tone = 'note',
  icon: Icon = Info,
}) {
  if (!children) return null;

  if (tone === 'sage') {
    return (
      <div
        data-ds-id="ds/message--sage"
        className={cn(
          'flex items-center gap-space-3 rounded-ds-lg border border-sage-border bg-sage-tint px-space-3 py-space-2-5',
          className,
        )}
      >
        <Icon className="size-4 shrink-0 text-sage-on-tint" weight="regular" aria-hidden />
        <div className="flex min-w-0 flex-1 flex-col gap-space-1">
          {title ? (
            <p className="m-0 text-type-body font-semibold leading-snug text-sage-on-tint">
              {title}
            </p>
          ) : null}
          <p
            className={cn(
              'm-0 leading-[1.4]',
              title
                ? 'text-type-label text-muted-foreground'
                : 'text-type-body font-semibold text-sage-on-tint',
            )}
          >
            {children}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      data-ds-id="ds/wizard/note"
      className={cn(
        'flex items-start gap-space-3 rounded-ds-lg border border-border bg-card p-space-4',
        className,
      )}
    >
      <Icon className="size-5 shrink-0 text-sage-600 dark:text-sage-400" weight="regular" aria-hidden />
      <div className="flex min-w-0 flex-1 flex-col gap-space-1">
        {title ? (
          <p className="m-0 text-type-label-lg font-semibold text-card-foreground">{title}</p>
        ) : null}
        <p className="m-0 text-type-body-sm leading-[1.5] text-muted-foreground">{children}</p>
      </div>
    </div>
  );
}

export default WizardHelpNote;
